<p class="modal-title">We have added Pure Deposits & Withdrawals</p>
<p class="modal-description">
  Skins Balance and Pure Balance are separated so our costumers get the
  opportunity to choose between Pure or Skins withdrawals based on their
  deposits.
</p>
<div class="compares table flex">
  <div class="column flex flex-col">
    <div class="head flex items-center justify-center odd">
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/core/skins.svg"
      />
      Skins Balance
    </div>
    <div class="cell border-bottom">
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/ui/checkmark.svg"
      />
      Skins Withdrawals
    </div>
    <div class="cell empty">-</div>
  </div>
  <div class="column flex flex-col">
    <div class="head flex items-center justify-center even">
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/core/pure.svg"
      />
      Pure Balance
    </div>
    <div class="cell border-bottom">
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/ui/checkmark.svg"
      />
      Skins Withdrawals
    </div>
    <div class="cell">
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/ui/checkmark.svg"
      />
      Pure Withdrawals
    </div>
  </div>
</div>
<div class="attention flex items-center">
  <svg-icon
    class="attention--icon flex items-center justify-center s-24"
    src="assets/icons/shared/info.svg"
  />
  <p>
    The following rewards including leaderboard, wager goals, daily cases,
    rakeback, faucet will go towards Skins Balance, our monthly raffle has 3
    balance prizes and the rest of the items are sent to your steam account via
    trade offer.
  </p>
</div>
